export default {"src":"/_next/static/media/logo-circle.9f6f8f1c.svg","height":149,"width":149,"blurWidth":0,"blurHeight":0};